{
  "$id": "common_definitions.json",
  "definitions": {
    "CogAtlasID": { "type": "string", "format": "uri" },
    "CogPOID": { "type": "string", "format": "uri" },
    "CoordUnits": { "type": "string", "enum": ["m", "mm", "cm", "n/a"] },
    "MEGCoordSys": {
      "type": "string",
      "enum": [
        "CTF",
        "ElektaNeuromag",
        "4DBti",
        "KitYokogawa",
        "ChietiItab",
        "Other"
      ]
    },
    "EEGCoordSys": {
      "type": "string",
      "enum": ["CapTrak", "EEGLAB", "EEGLAB-HJ", "Other"]
    },
    "iEEGCoordSys": {
      "type": "string",
      "enum": ["Pixels", "ACPC", "ScanRAS", "Other"]
    },
    "StandardTemplateCoordSys": {
      "type": "string",
      "enum": [
        "ICBM452AirSpace",
        "ICBM452Warp5Space",
        "IXI549Space",
        "fsaverage",
        "fsaverageSym",
        "fsLR",
        "MNIColin27",
        "MNI152Lin",
        "MNI152NLin2009aSym",
        "MNI152NLin2009bSym",
        "MNI152NLin2009cSym",
        "MNI152NLin2009aAsym",
        "MNI152NLin2009bAsym",
        "MNI152NLin2009cAsym",
        "MNI152NLin6Sym",
        "MNI152NLin6ASym",
        "MNI305",
        "NIHPD",
        "OASIS30AntsOASISAnts",
        "OASIS30Atropos",
        "Talairach",
        "UNCInfant"
      ]
    },
    "StandardTemplateDeprecatedCoordSys": {
      "type": "string",
      "enum": [
        "fsaverage3",
        "fsaverage4",
        "fsaverage5",
        "fsaverage6",
        "fsaveragesym",
        "UNCInfant0V21",
        "UNCInfant1V21",
        "UNCInfant2V21",
        "UNCInfant0V22",
        "UNCInfant1V22",
        "UNCInfant2V22",
        "UNCInfant0V23",
        "UNCInfant1V23",
        "UNCInfant2V23"
      ]
    },
    "DeviceSerialNumber": { "type": "string" },
    "ECGChannelCount": { "type": "integer", "minimum": 0 },
    "EEGChannelCount": { "type": "integer", "minimum": 0 },
    "NIRSChannelCount": { "type": "integer", "minimum": 0 },
    "NIRSSourceOptodeCount": { "type": "integer", "minimum": 0 },
    "NIRSDetectorOptodeCount": { "type": "integer", "minimum": 0 },
    "EMGChannelCount": { "type": "integer", "minimum": 0 },
    "EOGChannelCount": { "type": "integer", "minimum": 0 },
    "EpochLength": { "type": "number", "minimum": 0 },
    "HardwareFilters": {
      "anyOf": [
        { "type": "object", "additionalProperties": { "type": "object" } },
        { "type": "string", "pattern": "^n/a$" }
      ]
    },
    "InstitutionAddress": { "type": "string" },
    "InstitutionName": { "type": "string" },
    "Instructions": { "type": "string" },
    "InstitutionalDepartmentName": { "type": "string", "minLength": 1 },
    "LandmarkCoordinates": {
      "type": "object",
      "additionalProperties": {
        "type": "array",
        "items": {
          "type": "number"
        },
        "minItems": 3,
        "maxItems": 3
      }
    },
    "Manufacturer": { "type": "string", "minLength": 1 },
    "MiscChannelCount": { "type": "integer", "minimum": 0 },
    "PowerLineFrequency": {
      "anyOf": [
        { "type": "number", "exclusiveMinimum": 0 },
        { "type": "string", "pattern": "^n/a$" }
      ]
    },
    "RecordingDuration": { "type": "number" },
    "RecordingType": {
      "type": "string",
      "enum": ["continuous", "epoched", "discontinuous"]
    },
    "SamplingFrequency": { "type": "number" },
    "SoftwareFilters": {
      "anyOf": [
        { "type": "object", "additionalProperties": { "type": "object" } },
        { "type": "string", "pattern": "^n/a$" }
      ]
    },
    "SoftwareVersions": { "type": "string" },
    "TaskDescription": { "type": "string" },
    "TaskName": { "type": "string", "minLength": 1 },
    "TermURL": {
      "title": "TermURL",
      "description": "URL pointing to a formal definition in an ontology available on the web.",
      "type": "string",
      "format": "uri"
    },
    "TriggerChannelCount": { "type": "integer", "minimum": 0 },
    "ColumnDescription": {
      "type": "object",
      "title": "Column",
      "description": "Column of a corresponding tabular file.",
      "properties": {
        "LongName": {
          "title": "LongName",
          "description": " Long (unabbreviated) name of column.",
          "type": "string"
        },
        "Description": {
          "title": "Description",
          "description": "Description of the column.",
          "type": "string"
        },
        "Units": {
          "title": "Units",
          "description": "Measurement units.",
          "type": "string"
        },
        "Levels": {
          "type": "object",
          "title": "Levels",
          "description": "For categorical variables: a dictionary of possible values (keys) and their descriptions (values).",
          "patternProperties": {
            "^.+$": {
              "anyOf": [
                { "type": "string" },
                {
                  "type": "object",
                  "properties": {
                    "Description": { "type": "string" },
                    "TermURL": { "$ref": "#/definitions/TermURL" }
                  }
                }
              ]
            }
          }
        },
        "TermURL": { "$ref": "#/definitions/TermURL" },
        "HED": {
          "anyOf": [
            {
              "type": "object",
              "title": "HED",
              "description": "For categorical variables: a dictionary of possible values (keys) and their HED strings (values).",
              "patternProperties": {
                "^.+$": {
                  "type": "string"
                }
              }
            },
            {
              "type": "string",
              "title": "HED",
              "description": "For value variables: a string with a single '#' character where the cell value is to be interpolated."
            }
          ]
        }
      }
    }
  }
}
